import React, { ReactNode } from 'react'

import { BadgeWrapper } from './StyledComponents'
import { BirthdayBadge } from './badges/Birthday'
import { LoyaltyBadge } from './badges/Loyalty'
import { SecurityBadge } from './badges/Security'
import { PreferredBrowserBadge } from './badges/PreferredBrowser'

import { isBirthdayWeek } from './utils/birthday'
import { useHostCustomer } from '../../../hooks/useHostCustomer'

export type BadgeKey = 'birthday' | 'security' | 'loyalty' | 'preferredBrowser'

export type BadgeObj = {
  key: BadgeKey
  order: number
  Component: () => ReactNode
  isEligible: boolean
}
export type BadgesConfig = {
  key: BadgeKey
  order: number
  isEligible: boolean
}

const BADGE_COMPONENTS: Record<BadgeKey, React.FC> = {
  birthday: BirthdayBadge,
  loyalty: LoyaltyBadge,
  preferredBrowser: PreferredBrowserBadge,
  security: SecurityBadge,
}

function BadgeFactory(): JSX.Element {
  const {
    isAfg,
    isBankUser,
    afgCustomer,
    legacyCustomer,
    isSecurityFFOn,
  } = useHostCustomer()

  const bday = isAfg
    ? afgCustomer?.data?.dob ?? ''
    : legacyCustomer?.customer?.birthDatePvtEncrypt ?? ''
  const showBirthday = isBirthdayWeek(bday)
  const showSecurity = isBankUser && isSecurityFFOn

  const badges = [
    {
      name: 'birthday',
      order: 0,
      isEligible: showBirthday,
    },
    {
      name: 'loyalty',
      order: 1,
      isEligible: true,
    },
    {
      name: 'preferredBrowser',
      order: 2,
      isEligible: true,
    },
    {
      name: 'security',
      order: 3,
      isEligible: showSecurity,
    },
  ]

  const filterEligible = badges.filter(badge => badge.isEligible === true)
  const sortedEligible = filterEligible.sort((a, b) => a.order - b.order)
  const fourEligible = sortedEligible.slice(0, 4) // only space for 4 badges in widget

  return (
    <BadgeWrapper data-testid="badge-widget-content">
      {fourEligible.map(badge => {
        const BadgeComponent = BADGE_COMPONENTS[badge.name as BadgeKey]
        return (
          BadgeComponent && (
            <React.Fragment key={`${badge.name}-order-${badge.order}`}>
              <BadgeComponent />
            </React.Fragment>
          )
        )
      })}
    </BadgeWrapper>
  )
}

export { BadgeFactory }
